import { NAV_ROUTES } from '@/utils/constants';
import { logout } from '@/utils/logout';
import { LoaderData } from '@/types/types';
import { useMemo } from 'react';
import { useLoaderData, useNavigate, useSearchParams } from 'react-router-dom';
import { InvitationCardContent } from './InvitationCardContent';
import { InvitationPageShell } from './InvitationPageShell';
import { handleInvitationLoader } from './handleInvitationLoader';
import { getInvitationLoaderView } from './invitationLoaderView';
import { useAcceptInvitation } from './useAcceptInvitation';

export { handleInvitationLoader } from './handleInvitationLoader';

export function HandleInvitation() {
  const [searchParams] = useSearchParams();
  const loaderData = useLoaderData() as LoaderData<typeof handleInvitationLoader>;
  const navigate = useNavigate();
  const view = useMemo(() => getInvitationLoaderView(loaderData), [loaderData]);
  const { isAccepting, acceptError } = useAcceptInvitation(loaderData, searchParams);

  const handleLogInAsAnotherUser = async () => {
    await logout();
    const hash = searchParams.get('hash') ?? searchParams.get('invitationId');
    const invitationType = searchParams.get('invitationType');
    const url = encodeURIComponent(
      `/handleInvitation?hash=${hash}&invitationType=${invitationType}`,
    );
    navigate(`${NAV_ROUTES.login}?redirectUrl=${url}`);
  };

  const handleGoHome = () => {
    navigate(NAV_ROUTES.root);
  };

  return (
    <InvitationPageShell>
      <InvitationCardContent
        view={view}
        isAccepting={isAccepting}
        acceptError={acceptError}
        onLogInAsAnotherUser={handleLogInAsAnotherUser}
        onGoHome={handleGoHome}
      />
    </InvitationPageShell>
  );
}
